<template>
  <router-view></router-view>
</template>

<script>
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";

export default {

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    isConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    selectedDevice: function(newDevice, oldDevice) {

      if (newDevice.macList){
        const WSUnSubscribe = {
          deviceToken: getSelectedDeviceToken(oldDevice.mac),
          notification: false
        };
        if( WSUnSubscribe.deviceToken != null)
          //message without token will cause ws to disconnect
          this.$socket.send(JSON.stringify(WSUnSubscribe));
      }
      else if (newDevice.mac !== oldDevice.mac) {
        const WSUnSubscribe = {
          deviceToken: getSelectedDeviceToken(oldDevice.mac),
          notification: false
        };

        if( WSUnSubscribe.deviceToken != null)
          //message without token will cause ws to disconnect
          this.$socket.send(JSON.stringify(WSUnSubscribe));

        const WSSubscribe = {
          deviceToken: getSelectedDeviceToken(newDevice.mac),
          notification: true
        };

        if( WSSubscribe.deviceToken != null)
          //message without token will cause ws to disconnect
        this.$socket.send(JSON.stringify(WSSubscribe));
      }
    },

    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        this.statesSubscribe(true);
        this.notificationSubscribe(true);
      }
    }
  },

  methods: {
    notificationSubscribe: function(subscribe) {
      // const subscribeNotification = {
      //   deviceToken: getSelectedDeviceToken(this.selectedDevice.mac),
      //   notification: subscribe
      // };
      // this.$socket.send(JSON.stringify(subscribeNotification));

      let subscribeNotification = {
        notification: subscribe
      };

      if (this.selectedDevice.macList) {
        subscribeNotification.userToken = getUserToken();
        subscribeNotification.macList = this.selectedDevice.macList;
      } else {
        subscribeNotification.deviceToken = getSelectedDeviceToken(this.selectedDevice.mac);
        if( subscribeNotification.deviceToken === null)
         return;//message without token will caouse ws to disconnect
      }

      this.$socket.send(JSON.stringify(subscribeNotification));
    },

    statesSubscribe: function(subscribe) {
      const stateSubscribe = {
        userToken: getUserToken(),
        state: subscribe
      };
      this.$socket.send(JSON.stringify(stateSubscribe));
    },
  },

  mounted() {
    if (this.isConnected) {
      this.statesSubscribe(true);
      this.notificationSubscribe(true);
    }
  },

  beforeDestroy() {
    try {
      this.statesSubscribe(false);
      this.notificationSubscribe(false);
    } catch (err) {
      //console.log("Unable send unsubscribe from live data");
    }
  }

};
</script>
